<svelte:head>
  <meta http-equiv="refresh" content="0; URL=https://summerbo.at/404" />
  <meta name="robots" content="noindex" />
</svelte:head>

<div>
  <h2 class="text-large text-headline">404 Page Not Found</h2>
</div>
